"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueCustomAttributeTextFilter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useTranslations = require("../../utils/i18n/useTranslations");
var _DebouncedTextInput = require("../../utils/components/DebouncedTextInput");
var _sdk = require("../../../sdk");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IssueCustomAttributeTextFilter = _ref => {
  let {
    value,
    onChange,
    dataType,
    dataTestId
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const handleChangeEvent = (0, _react.useCallback)(e => {
    onChange(e.target.value);
  }, [onChange]);
  const isNumeric = dataType === _sdk.IssueCustomAttributeType.Numeric;
  return /*#__PURE__*/_react.default.createElement(_DebouncedTextInput.DebouncedTextInput, {
    style: {
      width: "100%"
    },
    value: value,
    onChange: handleChangeEvent,
    placeholder: isNumeric ? T.translate("customFieldsAdmin.placeholder.numeric") : T.translate("customFieldsAdmin.placeholder.text"),
    isNumeric: isNumeric,
    "data-testid": dataTestId
  });
};
exports.IssueCustomAttributeTextFilter = IssueCustomAttributeTextFilter;
//# sourceMappingURL=IssueCustomAttributeTextFilter.js.map